import React, { useMemo } from 'react';

import PaginationControls from '../components/controls/PaginationControls';

type PaginatedContentRendererProps<T> = {
  data: T[];
  itemsPerPage: number;
  activePage: number;
  setActivePage: (page: number) => void;
  children: (record: T) => React.ReactNode;
};
const PaginatedContentRenderer = <T extends {}>(props: PaginatedContentRendererProps<T>) => {
  const { data, itemsPerPage, activePage, setActivePage, children } = props;
  const totalCount = data.length;
  const visibleData = useMemo(
    () => [...data].slice(activePage * itemsPerPage, activePage * itemsPerPage + itemsPerPage),
    [data, activePage, itemsPerPage],
  );
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  return (
    <div>
      {visibleData.map((record) => children(record))}
      <div className="flex flex-col gap-2 items-center mt-4">
        {totalPages > 0 && <PaginationControls activePage={activePage} setActivePage={setActivePage} totalPages={totalPages} />}
      </div>
    </div>
  );
};
PaginatedContentRenderer.displayName = 'PaginatedContentRenderer';
export default PaginatedContentRenderer;
